import { addCalendarDays, istDateInput } from '../payments/paymentDates';
export function percentage(value: number | null) {
  return value == null ? '—' : `${value}%`;
}
export function duration(value: number | null) {
  if (value == null) return '—';
  const minutes = Math.round(value);
  if (minutes < 60) return `${minutes} min`;
  if (minutes < 1440)
    return `${Math.floor(minutes / 60)} h${minutes % 60 ? ` ${minutes % 60} min` : ''}`;
  return `${Math.floor(minutes / 1440)} d${Math.floor((minutes % 1440) / 60) ? ` ${Math.floor((minutes % 1440) / 60)} h` : ''}`;
}
export function apiRange(from: string, end: string) {
  return { from, to: addCalendarDays(end, 1) };
}
export function rangeError(from: string, end: string) {
  const start = Date.parse(`${from}T00:00:00Z`),
    finish = Date.parse(`${end}T00:00:00Z`);
  if (
    !Number.isFinite(start) ||
    !Number.isFinite(finish) ||
    new Date(start).toISOString().slice(0, 10) !== from ||
    new Date(finish).toISOString().slice(0, 10) !== end ||
    finish < start ||
    (finish - start) / 86400000 + 1 > 92
  )
    return 'Choose an inclusive range of 1–92 days.';
  return null;
}
export function thisWeek(now = new Date()) {
  const end = istDateInput(now);
  const day = new Date(`${end}T00:00:00Z`).getUTCDay();
  return { from: addCalendarDays(end, -((day + 6) % 7)), end };
}
export function trendPath(values: (number | null)[]) {
  let connected = false;
  return values
    .map((value, index) => {
      if (value == null) {
        connected = false;
        return '';
      }
      const command = connected ? 'L' : 'M';
      connected = true;
      return `${command}${40 + (index * 620) / Math.max(1, values.length - 1)},${220 - value * 2}`;
    })
    .filter(Boolean)
    .join(' ');
}
